module.exports = __webpack_public_path__ + "img/extern-link.1a66f7fb.svg";